export const Language = {
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
};

export const Manager = {
  CHANGE_UPDATE_POPUP_CLOSE: 'CHANGE_UPDATE_POPUP_CLOSE',
  CHANGE_UPDATE_CLIENTSTATUS_SOUND: 'CHANGE_UPDATE_CLIENTSTATUS_SOUND',
  CHANGE_UPDATE_CLIENTSTATUS_TYPE: 'CHANGE_UPDATE_CLIENTSTATUS_TYPE',

  // 로그인 성공/실패
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
  SIGN_IN_RESET: 'SIGN_IN_RESET',

  // 로그아웃
  SIGN_OUT: 'SIGN_OUT',

  // AccessToken 갱신
  TOKEN_REFRESH_REQUEST: 'TOKEN_REFRESH_REQUEST',
  TOKEN_REFRESH_SUCCESS: 'TOKEN_REFRESH_SUCCESS',
  TOKEN_REFRESH_FAILURE: 'TOKEN_REFRESH_FAILURE',

  // 공지사항 팝업 조회
  LOAD_NOTICE_POPUP_REQUEST: 'LOAD_NOTICE_POPUP_REQUEST',
  LOAD_NOTICE_POPUP_REQUEST_SUCCESS: 'LOAD_NOTICE_POPUP_REQUEST_SUCCESS',
  LOAD_NOTICE_POPUP_REQUEST_FAILURE: 'LOAD_NOTICE_POPUP_REQUEST_FAILURE',
};

export const Menu = {
  // 이벤트
  MOVE_MENU: 'MOVE_MENU',
  RESET_MENU_LIST: 'RESET_MENU_LIST',

  CHANGE_CURRENT_MENU: 'CHANGE_CURRENT_MENU',
  CHANGE_ASIDE_MENU_OPEN: 'CHANGE_ASIDE_MENU_OPEN',
  HAMBURGER_MENU_OPEN: 'HAMBURGER_MENU_OPEN',

  // 메뉴 조회
  LOAD_MENU_REQUEST: 'LOAD_MENU_REQUEST',
  LOAD_MENU_SUCCESS: 'LOAD_MENU_SUCCESS',
  LOAD_MENU_FAILURE: 'LOAD_MENU_FAILURE',
};

export const ShopNotification = {
  RESET_ALL_HUB: 'RESET_ALL_HUB',

  CHANGE_SHOP_NOTIFICATION_HUB: 'CHANGE_SHOP_NOTIFICATION_HUB',

  CHANGE_SHOP_NOTIFICATION: 'CHANGE_SHOP_NOTIFICATION',
  SHOW_SHOP_NOTIFICATION: 'SHOW_SHOP_NOTIFICATION',

  LOAD_SHOP_NOTIFICATION_INFO_REQUEST: 'LOAD_SHOP_NOTIFICATION_INFO_REQUEST',
  LOAD_SHOP_NOTIFICATION_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_NOTIFICATION_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_NOTIFICATION_INFO_REQUEST_FAILURE: 'LOAD_SHOP_NOTIFICATION_INFO_REQUEST_FAILURE',
};

export const CallNotification = {
  CHANGE_CALL_NOTIFICATION: 'CHANGE_CALL_NOTIFICATION',
  LOAD_CALL_NOTIFICATION_INFO_REQUEST_SUCCESS: 'LOAD_CALL_NOTIFICATION_INFO_REQUEST_SUCCESS',
};

export const Billing = {
  CHANGE_IS_RECURRING_PAYMENT: 'CHANGE_IS_RECURRING_PAYMENT',
  CHANGE_IS_INVENTORY: 'CHANGE_IS_INVENTORY',
};

export const Exceoption = {
  ERROR: '',
};

export const Loader = {
  CHANGE_LOADING_REQUEST: 'CHANGE_LOADING_REQUEST',
  CHANGE_LOADING_RESPONSE: 'CHANGE_LOADING_RESPONSE',
  CHANGE_PAGE_LOAD: 'CHANGE_PAGE_LOAD',
};

export const SignIn = {
  // 이벤트
  CHANGE_ID: 'CHANGE_ID',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CHANGE_REMEMBER: 'CHANGE_REMEMBER',
  RESET_DATA: 'RESET_DATA',

  // 로그인
  SIGN_IN_REQUEST: 'SIGN_IN_REQUEST',
};

export const Code = {
  // 코드 목록 조회
  LOAD_CODE_LIST_REQUEST: 'LOAD_CODE_LIST_REQUEST',
  LOAD_CODE_LIST_SUCCESS: 'LOAD_CODE_LIST_SUCCESS',
  LOAD_CODE_LIST_FAILURE: 'LOAD_CODE_LIST_FAILURE',
};

export const SystemSetting = {
  // 시스템 세팅 목록 조회
  LOAD_SYSTEM_SETTING_LIST_REQUEST: 'LOAD_SYSTEM_SETTING_LIST_REQUEST',
  LOAD_SYSTEM_SETTING_LIST_REQUEST_SUCCESS: 'LOAD_SYSTEM_SETTING_LIST_REQUEST_SUCCESS',
  LOAD_SYSTEM_SETTING_LIST_REQUEST_FAILURE: 'LOAD_SYSTEM_SETTING_LIST_REQUEST_FAILURE',
};

export const Scorecard = {
  // 이벤트
  CHANGE_SCORECARD: 'CHANGE_SCORECARD',

  // 스코어카드 정보 조회
  LOAD_SCORECARD_INFO_REQUEST: 'LOAD_SCORECARD_INFO_REQUEST',
  LOAD_SCORECARD_INFO_SUCCESS: 'LOAD_SCORECARD_INFO_SUCCESS',
  LOAD_SCORECARD_INFO_FAILURE: 'LOAD_SCORECARD_INFO_FAILURE',
};

export const Popup = {
  CHANGE_POPUP_VIEW: 'CHANGE_POPUP_VIEW',
  CHANGE_POPUP_TYPE: 'CHANGE_POPUP_TYPE',
  CLOSE_POPUP: 'CLOSE_POPUP',
};

/* ============================================================================================================ */
/* 매장 정보 */

export const ShopInfo = {
  // 이벤트
  CHANGE_SHOP_INFO: 'CHANGE_SHOP_INFO',
  CHANGE_SHOP_CLIENT_INFO_SETTING_GUID: 'CHANGE_SHOP_CLIENT_INFO_SETTING_GUID',
  CHANGE_SHOP_CLIENT_INFO: 'CHANGE_SHOP_CLIENT_INFO',

  // 매장 정보 조회
  LOAD_SHOP_INFO_REQUEST: 'LOAD_SHOP_INFO_REQUEST',
  LOAD_SHOP_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_INFO_REQUEST_FAILURE: 'LOAD_SHOP_INFO_REQUEST_FAILURE',

  // 매장 클라이언트 목록 조회
  LOAD_SHOP_CLIENT_LIST_REQUEST: 'LOAD_SHOP_CLIENT_LIST_REQUEST',
  LOAD_SHOP_CLIENT_LIST_REQUEST_SUCCESS: 'LOAD_SHOP_CLIENT_LIST_REQUEST_SUCCESS',
  LOAD_SHOP_CLIENT_LIST_REQUEST_FAILURE: 'LOAD_SHOP_CLIENT_LIST_REQUEST_FAILURE',

  // 매장 정보 수정
  EDIT_SHOP_INFO_REQUEST: 'EDIT_SHOP_INFO_REQUEST',
  EDIT_SHOP_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_INFO_REQUEST_FAILURE: 'EDIT_SHOP_INFO_REQUEST_FAILURE',

  // 매장 영업 정보 수정
  EDIT_SHOP_SALES_INFO_REQUEST: 'EDIT_SHOP_SALES_INFO_REQUEST',
  EDIT_SHOP_SALES_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_SALES_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_SALES_INFO_REQUEST_FAILURE: 'EDIT_SHOP_SALES_INFO_REQUEST_FAILURE',
  EDIT_SHOP_SALES_IMAGE_REQUEST: 'EDIT_SHOP_SALES_IMAGE_REQUEST',
  EDIT_SHOP_SALES_IMAGE_REQUEST_SUCCESS: 'EDIT_SHOP_SALES_IMAGE_REQUEST_SUCCESS',
  EDIT_SHOP_SALES_IMAGE_REQUEST_FAILURE: 'EDIT_SHOP_SALES_IMAGE_REQUEST_FAILURE',

  // 매장 클라이언트 정보 수정
  EDIT_SHOP_CLIENT_INFO_REQUEST: 'EDIT_SHOP_CLIENT_INFO_REQUEST',
  EDIT_SHOP_CLIENT_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_CLIENT_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_CLIENT_INFO_REQUEST_FAILURE: 'EDIT_SHOP_CLIENT_INFO_REQUEST_FAILURE',

  // 매장 지역 조회
  LOAD_SHOP_LOCATIONS_REQUEST: 'LOAD_SHOP_LOCATIONS_REQUEST',
  LOAD_SHOP_LOCATIONS_REQUEST_SUCCESS: 'LOAD_SHOP_LOCATIONS_REQUEST_SUCCESS',
  LOAD_SHOP_LOCATIONS_REQUEST_FAILURE: 'LOAD_SHOP_LOCATIONS_REQUEST_FAILURE',

  // 전체 매장 리스트 조회
  LOAD_ALL_SHOP_LIST_REQUEST: 'LOAD_ALL_SHOP_LIST_REQUEST',
  LOAD_ALL_SHOP_LIST_REQUEST_SUCCESS: 'LOAD_ALL_SHOP_LIST_REQUEST_SUCCESS',
  LOAD_ALL_SHOP_LIST_REQUEST_FAILURE: 'LOAD_ALL_SHOP_LIST_REQUEST_FAILURE',
};

export const ShopManagerInfo = {
  // 이벤트
  CHANGE_SHOP_MANAGER_INFO: 'CHANGE_SHOP_MANAGER_INFO',

  // 매장 직원 정보 조회
  LOAD_SHOP_MANAGER_INFO_REQUEST: 'LOAD_SHOP_MANAGER_INFO_REQUEST',
  LOAD_SHOP_MANAGER_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_MANAGER_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_MANAGER_INFO_REQUEST_FAILURE: 'LOAD_SHOP_MANAGER_INFO_REQUEST_FAILURE',

  // 매장 직원 정보 수정
  EDIT_SHOP_MANAGER_INFO_REQUEST: 'EDIT_SHOP_MANAGER_INFO_REQUEST',
  EDIT_SHOP_MANAGER_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_MANAGER_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_MANAGER_INFO_REQUEST_FAILURE: 'EDIT_SHOP_MANAGER_INFO_REQUEST_FAILURE',
};

export const ShopClientInfo = {

  // 매장 클라이언트 비번 수정
  EDIT_SHOP_CLIENT_PW_REQUEST: 'EDIT_SHOP_CLIENT_PW_REQUEST',
  EDIT_SHOP_CLIENT_PW_REQUEST_SUCCESS: 'EDIT_SHOP_CLIENT_PW_REQUEST_SUCCESS',
  EDIT_SHOP_CLIENT_PW_REQUEST_FAILURE: 'EDIT_SHOP_CLIENT_PW_REQUEST_FAILURE',
};

export const ShopGameRoundOptionSetting = {
  // 이벤트
  CHANGE_SHOP_GAME_ROUND_OPTION_SETTING_INFO: 'CHANGE_SHOP_GAME_ROUND_OPTION_SETTING_INFO',

  // 매장 게임 라운드 옵션 설정 정보 조회
  LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST: 'LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST',
  LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE: 'LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE',

  // 매장 게임 라운드 옵션 설정 정보 수정
  EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST: 'EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST',
  EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE: 'EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE',
};

export const ShopDrivingRangeOptionSetting = {
  // 이벤트
  CHANGE_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO: 'CHANGE_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO',

  // 매장 게임 라운드 옵션 설정 정보 조회
  LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST: 'LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST',
  LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE: 'LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE',

  // 매장 게임 라운드 옵션 설정 정보 수정
  EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST: 'EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST',
  EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE: 'EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE',
};

export const ShopClientRealTimeControlOptionSetting = {
  // 이벤트
  CHANGE_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO: 'CHANGE_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO',

  // 매장 클라이언트 실시간 제어 옵션 설정 정보 조회
  LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST: 'LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST',
  LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE: 'LOAD_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE',

  // 매장 클라이언트 실시간 제어 옵션 설정 정보 수정
  EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST: 'EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST',
  EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS: 'EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_SUCCESS',
  EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE: 'EDIT_SHOP_CLIENT_REAL_TIME_CONTROL_OPTION_SETTING_INFO_REQUEST_FAILURE',
};

/* ============================================================================================================ */

/* ============================================================================================================ */
/* 게임 내역 */

export const GameHistory = {
  // 이벤트
  CHANGE_SEARCH_FILTER: 'CHANGE_SEARCH_FILTER',
  CHANGE_CLIENT_ALL_CHECKED: 'CHANGE_CLIENT_ALL_CHECKED',

  // 게임 내역 목록 조회
  LOAD_GAME_HISTORY_LIST_REQUEST: 'LOAD_GAME_HISTORY_LIST_REQUEST',
  LOAD_GAME_HISTORY_LIST_SUCCESS: 'LOAD_GAME_HISTORY_LIST_SUCCESS',
  LOAD_GAME_HISTORY_LIST_FAILURE: 'LOAD_GAME_HISTORY_LIST_FAILURE',

  // 게임 내역 엑셀 조회
  LOAD_GAME_HISTORY_EXCEL_REQUEST: 'LOAD_GAME_HISTORY_EXCEL_REQUEST',
  LOAD_GAME_HISTORY_EXCEL_SUCCESS: 'LOAD_GAME_HISTORY_EXCEL_SUCCESS',
  LOAD_GAME_HISTORY_EXCEL_FAILURE: 'LOAD_GAME_HISTORY_EXCEL_FAILURE',
};

/* ============================================================================================================ */

/* ============================================================================================================ */
/* 타석 현황 */

export const ClientStatusList = {
  // 이벤트
  CHANGE_CLIENT_STATUS_SEARCH_FILTER: 'CHANGE_CLIENT_STATUS_SEARCH_FILTER',

  // 클라이언트 현황 목록 조회
  LOAD_CLIENT_STATUS_LIST_REQUEST: 'LOAD_CLIENT_STATUS_LIST_REQUEST',
  LOAD_CLIENT_STATUS_LIST_REQUEST_SUCCESS: 'LOAD_CLIENT_STATUS_LIST_REQUEST_SUCCESS',
  LOAD_CLIENT_STATUS_LIST_REQUEST_FAILURE: 'LOAD_CLIENT_STATUS_LIST_REQUEST_FAILURE',

  // 단일 클라이언트 업데이트
  CHANGE_CLIENT_STATUS: 'CHANGE_CLIENT_STATUS',
};

export const ClientStatusInfo = {
  // 이벤트
  CHANGE_CLIENT_INFO: 'CHANGE_CLIENT_INFO',
  CHANGE_GAME_ROUND_SETTING: 'CHANGE_GAME_ROUND_SETTING',
  CHANGE_CLIENT_LIMIT_SETTING: 'CHANGE_CLIENT_LIMIT_SETTING',
  CHANGE_REAL_TIME_CONTROL_OPTION_DEFAULT_SETTING: 'CHANGE_REAL_TIME_CONTROL_OPTION_DEFAULT_SETTING',

  // 클라이언트 현황 정보 조회
  LOAD_CLIENT_STATUS_INFO_REQUEST: 'LOAD_CLIENT_STATUS_INFO_REQUEST',
  LOAD_CLIENT_STATUS_INFO_SUCCESS: 'LOAD_CLIENT_STATUS_INFO_SUCCESS',
  LOAD_CLIENT_STATUS_INFO_FAILURE: 'LOAD_CLIENT_STATUS_INFO_FAILURE',

  // 게임 라운드 설정 조회
  LOAD_GAME_ROUND_SETTING_REQUEST: 'LOAD_GAME_ROUND_SETTING_REQUEST',
  LOAD_GAME_ROUND_SETTING_SUCCESS: 'LOAD_GAME_ROUND_SETTING_SUCCESS',
  LOAD_GAME_ROUND_SETTING_FAILURE: 'LOAD_GAME_ROUND_SETTING_FAILURE',
};

export const RealTimeCommunicationHub = {
  CHANGE_REAL_TIME_COMMUNICATION_HUB: 'CHANGE_REAL_TIME_COMMUNICATION_HUB',

  RESET_TIMER: 'RESET_TIMER',
};

/* ============================================================================================================ */

/* ============================================================================================================ */
/* 결제 관리 */

// 결제 정보 관리
export const PaymentInfo = {
  // 이벤트
  CHANGE_SHOP_BILL_RECEIVE_INFO: 'CHANGE_SHOP_BILL_RECEIVE_INFO',

  // 매장 명세서 수신 여부 조회
  LOAD_SHOP_BILL_RECEIVE_INFO_REQUEST: 'LOAD_SHOP_BILL_RECEIVE_INFO_REQUEST',
  LOAD_SHOP_BILL_RECEIVE_INFO_SUCCESS: 'LOAD_SHOP_BILL_RECEIVE_INFO_SUCCESS',
  LOAD_SHOP_BILL_RECEIVE_INFO_FAILURE: 'LOAD_SHOP_BILL_RECEIVE_INFO_FAILURE',
};

// 정기 결제 관리
export const RecurringPayment = {
  // 이벤트
  CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN: 'CHANGE_PAYMENT_REQUEST_OPEN',

  // 매장 정기결제 조회
  LOAD_SHOP_RECURRING_PAYMENT_REQUEST: 'LOAD_SHOP_RECURRING_PAYMENT_REQUEST',
  LOAD_SHOP_RECURRING_PAYMENT_SUCCESS: 'LOAD_SHOP_RECURRING_PAYMENT_SUCCESS',
  LOAD_SHOP_RECURRING_PAYMENT_FAILURE: 'LOAD_SHOP_RECURRING_PAYMENT_FAILURE',

  // 매장 결제 방법 조회
  LOAD_SHOP_PAYMENT_METHOD_REQUEST: 'LOAD_SHOP_PAYMENT_METHOD_REQUEST',
  LOAD_SHOP_PAYMENT_METHOD_SUCCESS: 'LOAD_SHOP_PAYMENT_METHOD_SUCCESS',
  LOAD_SHOP_PAYMENT_METHOD_FAILURE: 'LOAD_SHOP_PAYMENT_METHOD_FAILURE',

  // 매장 결제 방법 추가
  ADD_SHOP_PAYMENT_METHOD_REQUEST: 'ADD_SHOP_PAYMENT_METHOD_REQUEST',
  ADD_SHOP_PAYMENT_METHOD_SUCCESS: 'ADD_SHOP_PAYMENT_METHOD_SUCCESS',
  ADD_SHOP_PAYMENT_METHOD_FAILURE: 'ADD_SHOP_PAYMENT_METHOD_FAILURE',

  // 매장 결제 방법 삭제
  DELETE_SHOP_PAYMENT_METHOD_REQUEST: 'DELETE_SHOP_PAYMENT_METHOD_REQUEST',
  DELETE_SHOP_PAYMENT_METHOD_SUCCESS: 'DELETE_SHOP_PAYMENT_METHOD_SUCCESS',
  DELETE_SHOP_PAYMENT_METHOD_FAILURE: 'DELETE_SHOP_PAYMENT_METHOD_FAILURE',

  // 매장 정기결제 서비스 이용 중지
  SHOP_RECURRING_PAYMENT_CANCEL_REQUEST: 'SHOP_RECURRING_PAYMENT_CANCEL_REQUEST',
  SHOP_RECURRING_PAYMENT_CANCEL_SUCCESS: 'SHOP_RECURRING_PAYMENT_CANCEL_SUCCESS',
  SHOP_RECURRING_PAYMENT_CANCEL_FAILURE: 'SHOP_RECURRING_PAYMENT_CANCEL_FAILURE',

  // 세틀뱅크 내통장결제 인증
  MY_BANK_ACCOUNT_PAYMENT_APPROVAL_REQUEST: 'MY_BANK_ACCOUNT_PAYMENT_APPROVAL_REQUEST',
  MY_BANK_ACCOUNT_PAYMENT_APPROVAL_FAILURE: 'MY_BANK_ACCOUNT_PAYMENT_APPROVAL_FAILURE',

  // 세틀뱅크 전자결제 신용카드 구인증 결제 확인
  CREDIT_CARD_PAYMENT_VERIFY_REQUEST: 'CREDIT_CARD_PAYMENT_VERIFY_REQUEST',
  CREDIT_CARD_PAYMENT_VERIFY_FAILURE: 'CREDIT_CARD_PAYMENT_VERIFY_FAILURE',
};

// 요금납부
export const Payment = {
  // 이벤트
  CHANGE_CHARGES_PAYMENT_TYPE: 'CHANGE_CHARGES_PAYMENT_TYPE',
  CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN: 'CHANGE_PAYMENT_REQUEST_OPEN',

  // 매장 요금 조회
  LOAD_SHOP_CHARGES_REQUEST: 'LOAD_SHOP_CHARGES_REQUEST',
  LOAD_SHOP_CHARGES_REQUEST_SUCCESS: 'LOAD_SHOP_CHARGES_REQUEST_SUCCESS',
  LOAD_SHOP_CHARGES_REQUEST_FAILURE: 'LOAD_SHOP_CHARGES_REQUEST_FAILURE',

  // 결제 날짜 조회
  LOAD_PAYMENT_DATE_REQUEST: 'LOAD_PAYMENT_DATE_REQUEST',
  LOAD_PAYMENT_DATE_REQUEST_SUCCESS: 'LOAD_PAYMENT_DATE_REQUEST_SUCCESS',
  LOAD_PAYMENT_DATE_REQUEST_FAILURE: 'LOAD_PAYMENT_DATE_REQUEST_FAILURE',

  // 매장 요금 결제
  SHOP_CHARGES_PAYMENT_REQUEST: 'SHOP_CHARGES_PAYMENT_REQUEST',
  SHOP_CHARGES_PAYMENT_REQUEST_SUCCESS: 'SHOP_CHARGES_PAYMENT_REQUEST_SUCCESS',
  SHOP_CHARGES_PAYMENT_REQUEST_FAILURE: 'SHOP_CHARGES_PAYMENT_REQUEST_FAILURE',
};

// 명세서 조회
export const Bills = {
  // 매장 청구서 목록 조회
  LOAD_SHOP_BILLS_REQUEST: 'LOAD_SHOP_BILLS_REQUEST',
  LOAD_SHOP_BILLS_REQUEST_SUCCESS: 'LOAD_SHOP_BILLS_REQUEST_SUCCESS',
  LOAD_SHOP_BILLS_REQUEST_FAILURE: 'LOAD_SHOP_BILLS_REQUEST_FAILURE',

  // 매장 청구서 상세 조회
  LOAD_SHOP_BILLS_DETAIL_REQUEST: 'LOAD_SHOP_BILLS_DETAIL_REQUEST',
  LOAD_SHOP_BILLS_DETAIL_REQUEST_SUCCESS: 'LOAD_SHOP_BILLS_DETAIL_REQUEST_SUCCESS',
  LOAD_SHOP_BILLS_DETAIL_REQUEST_FAILURE: 'LOAD_SHOP_BILLS_DETAIL_REQUEST_FAILURE',
};

/* ============================================================================================================ */

/* ============================================================================================================ */
/* 고객센터 */

// 공지사항
export const Notice = {
  // 이벤트
  CHANGE_NOTICE_SEARCH_FILTER: 'CHANGE_NOTICE_SEARCH_FILTER',

  // 검색 필터 초기화
  SEARCH_FILTER_RESET: 'SEARCH_FILTER_RESET',

  // 공지사항 글 목록 조회
  LOAD_NOTICE_LIST_REQUEST: 'LOAD_NOTICE_LIST_REQUEST',
  LOAD_NOTICE_LIST_SUCCESS: 'LOAD_NOTICE_LIST_SUCCESS',
  LOAD_NOTICE_LIST_FAILURE: 'LOAD_NOTICE_LIST_FAILURE',

  // 공지사항 글 상세 조회
  LOAD_NOTICE_INFO_REQUEST: 'LOAD_NOTICE_INFO_REQUEST',
  LOAD_NOTICE_INFO_SUCCESS: 'LOAD_NOTICE_INFO_SUCCESS',
  LOAD_NOTICE_INFO_FAILURE: 'LOAD_NOTICE_INFO_FAILURE',
};

// 문의하기
export const Qna = {
  // 이벤트
  CHANGE_SEARCH_FILTER: 'CHANGE_SEARCH_FILTER',
  CHANGE_QUESTION: 'CHANGE_QUESTION',
  ADD_QUESTION: 'ADD_QUESTION',

  // 검색 필터 초기화
  SEARCH_QNA_FILTER_RESET: 'SEARCH_QNA_FILTER_RESET',

  // 문의 목록 조회
  LOAD_QNA_LIST_REQUEST: 'LOAD_QNALIST_REQUEST',
  LOAD_QNA_LIST_SUCCESS: 'LOAD_QNALIST_SUCCESS',
  LOAD_QNA_LIST_FAILURE: 'LOAD_QNALIST_FAILURE',

  // 문의 등록
  ADD_QNA_QUESTION_REQUEST: 'ADD_QNA_QUESTION_REQUEST',
  ADD_QNA_QUESTION_SUCCESS: 'ADD_QNA_QUESTION_SUCCESS',
  ADD_QNA_QUESTION_FAILURE: 'ADD_QNA_QUESTION_FAILURE',

  // 문의 상세 조회
  LOAD_QNA_INFO_REQUEST: 'LOAD_QNA_INFO_REQUEST',
  LOAD_QNA_INFO_SUCCESS: 'LOAD_QNA_INFO_SUCCESS',
  LOAD_QNA_INFO_FAILURE: 'LOAD_QNA_INFO_FAILURE',
};

/* ============================================================================================================ */

/* ============================================================================================================ */
/* 매장 대회 */

// 매장 대회 목록
export const TournamentList = {
  // 이벤트
  CHANGE_TOURNAMENT_LIST_FILTER_DATA: 'CHANGE_TOURNAMENT_LIST_FILTER_DATA',

  // 매장 대회 목록 조회
  LOAD_TOURNAMENT_LIST_REQUEST: 'LOAD_TOURNAMENT_LIST_REQUEST',
  LOAD_TOURNAMENT_LIST_REQUEST_SUCCESS: 'LOAD_TOURNAMENT_LIST_REQUEST_SUCCESS',
  LOAD_TOURNAMENT_LIST_REQUEST_FAILURE: 'LOAD_TOURNAMENT_LIST_REQUEST_FAILURE',

  // 매장 대회 삭제
  DELETE_TOURNAMENT_REQUEST: 'DELETE_TOURNAMENT_REQUEST',
  DELETE_TOURNAMENT_REQUEST_SUCCESS: 'DELETE_TOURNAMENT_REQUEST_SUCCESS',
  DELETE_TOURNAMENT_REQUEST_FAILURE: 'DELETE_TOURNAMENT_REQUEST_FAILURE',

  // 매장 대회 조기 종료
  EARLY_TOURNAMENT_REQUEST: 'EARLY_TOURNAMENT_REQUEST',
  EARLY_TOURNAMENT_REQUEST_SUCCESS: 'EARLY_TOURNAMENT_REQUEST_SUCCESS',
  EARLY_TOURNAMENT_REQUEST_FAILURE: 'EARLY_TOURNAMENT_REQUEST_FAILURE',
};

// 매장 대회 개설
export const TournamentOpen = {
  // 이벤트
  RESET_TOURNAMENT_DATA: 'RESET_TOURNAMENT_DATA',
  CHANGE_TOURNAMENT_OPEN_STEP: 'CHANGE_TOURNAMENT_OPEN_STEP',
  CATCH_TOURNAMENT_PARAMS: 'CATCH_TOURNAMENT_PARAMS',
  CHANGE_TOURNAMENT_DATA: 'CHANGE_TOURNAMENT_DATA',
  CHANGE_TOURNAMENT_PARTICIPATIONSHOPS_DATA: 'CHANGE_TOURNAMENT_PARTICIPATIONSHOPS_DATA',
  CHANGE_TOURNAMENT_PARTICIPATION_TARGETS_DATA: 'CHANGE_TOURNAMENT_PARTICIPATION_TARGETS_DATA',
  RESET_TOURNAMENT_PARTICIPATION_TARGETS_DATA: 'RESET_TOURNAMENT_PARTICIPATION_TARGETS_DATA',
  CHANGE_TOURNAMENT_PARTICIPATION_GRADES_DATA: 'CHANGE_TOURNAMENT_PARTICIPATION_GRADES_DATA',
  CHANGE_TOURNAMENT_COURSE_ROUNDS_DATA: 'CHANGE_TOURNAMENT_COURSE_ROUNDS_DATA',
  CHANGE_TOURNAMENT_AWARDS_DATA: 'CHANGE_TOURNAMENT_AWARDS_DATA',
  CHANGE_TOURNAMENT_ID: 'CHANGE_TOURNAMENT_ID',
  CHANGE_TOURNAMENT_PARTICIPATION_GRADE_LIST_ITEM: 'CHANGE_TOURNAMENT_PARTICIPATION_GRADE_LIST_ITEM',
  CHANGE_TOURNAMENT_IS_PARTICIPATION_GRADE_ALL_CHECKED: 'CHANGE_TOURNAMENT_IS_PARTICIPATION_GRADE_ALL_CHECKED',

  // 매장 대회 로우 데이터 조회
  LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST: 'LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST',
  LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_SUCCESS: 'LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_SUCCESS',
  LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_FAILURE: 'LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_FAILURE',

  // 매장 대회 약관 조회
  LOAD_SHOP_TOURNAMENT_TERMS_REQUEST: 'LOAD_SHOP_TOURNAMENT_TERMS_REQUEST',
  LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_SUCCESS: 'LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_SUCCESS',
  LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_FAILURE: 'LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_FAILURE',

  // 매장 대회 코스 목록 조회
  LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST: 'LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST',
  LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_SUCCESS: 'LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_SUCCESS',
  LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_FAILURE: 'LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_FAILURE',

  // 매장 대회 코스 상세 조회
  LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST: 'LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST',
  LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_SUCCESS: 'LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_SUCCESS',
  LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_FAILURE: 'LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_FAILURE',

  // 매장 대회 개설
  ADD_SHOP_TOURNAMENT_REQUEST: 'ADD_SHOP_TOURNAMENT_REQUEST',
  ADD_SHOP_TOURNAMENT_REQUEST_SUCCESS: 'ADD_SHOP_TOURNAMENT_REQUEST_SUCCESS',
  ADD_SHOP_TOURNAMENT_REQUEST_FAILURE: 'ADD_SHOP_TOURNAMENT_REQUEST_FAILURE',

  // 매장 대회 수정
  MODIFY_SHOP_TOURNAMENT_REQUEST: 'MODIFY_SHOP_TOURNAMENT_REQUEST',
  MODIFY_SHOP_TOURNAMENT_REQUEST_SUCCESS: 'MODIFY_SHOP_TOURNAMENT_REQUEST_SUCCESS',
  MODIFY_SHOP_TOURNAMENT_REQUEST_FAILURE: 'MODIFY_SHOP_TOURNAMENT_REQUEST_FAILURE',
};

// 매장 대회 상세보기
export const TournamentDetails = {
  // 이벤트
  CHANGE_TOURNAMENT_DETAILS_TAB: 'CHANGE_TOURNAMENT_DETAILS_TAB',
  CHANGE_TOURNAMENT_RANKING_OPTION_DATA: 'CHANGE_TOURNAMENT_RANKING_OPTION_DATA',
  CHANGE_TOURNAMENT_AWARD_HISTORY_AWARD_INDEX: 'CHANGE_TOURNAMENT_AWARD_HISTORY_AWARD_INDEX',
  RESET_TOURNAMENT_RANKING_OPTION_DATA: 'RESET_TOURNAMENT_RANKING_OPTION_DATA',
  RESET_TOURNAMENT_RANKING_DATA: 'RESET_TOURNAMENT_RANKING_DATA',

  // 매장 대회 상세보기 조회
  LOAD_TOURNAMENT_DETAILS_REQUEST: 'LOAD_TOURNAMENT_DETAILS_REQUEST',
  LOAD_TOURNAMENT_DETAILS_REQUEST_SUCCESS: 'LOAD_TOURNAMENT_DETAILS_REQUEST_SUCCESS',
  LOAD_TOURNAMENT_DETAILS_REQUEST_FAILURE: 'LOAD_TOURNAMENT_DETAILS_REQUEST_FAILURE',

  // 매장 대회 랭킹 조회
  LOAD_TOURNAMENT_RANKING_REQUEST: 'LOAD_TOURNAMENT_RANKING_REQUEST',
  LOAD_TOURNAMENT_RANKING_REQUEST_SUCCESS: 'LOAD_TOURNAMENT_RANKING_REQUEST_SUCCESS',
  LOAD_TOURNAMENT_RANKING_REQUEST_FAILURE: 'LOAD_TOURNAMENT_RANKING_REQUEST_FAILURE',

  // 매장 대회 전체 랭킹 조회
  LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST: 'LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST',
  LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_SUCCESS: 'LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_SUCCESS',
  LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_FAILURE: 'LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_FAILURE',

  // 매장 대회 수상자 목록 조회
  LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST: 'LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST',
  LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_SUCCESS: 'LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_SUCCESS',
  LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_FAILURE: 'LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_FAILURE',

  // 매장 대회 코스별 시상 제외
  EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST: 'EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST',
  EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS: 'EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS',
  EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE: 'EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE',

  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST',
  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS',
  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE',

  // 매장 대회 종합 시상 제외
  EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST: 'EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST',
  EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS: 'EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS',
  EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE: 'EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE',

  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST',
  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS',
  ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE: 'ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE',

  // 매장 대회 참가자 추가 핸디캡 설정
  TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST: 'TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST',
  TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_SUCCESS: 'TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_SUCCESS',
  TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_FAILURE: 'TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_FAILURE',

  // 매장 대회 시상 초기화
  RESET_TOURNAMENT_AWARDS_REQUEST: 'RESET_TOURNAMENT_AWARDS_REQUEST',
  RESET_TOURNAMENT_AWARDS_REQUEST_SUCCESS: 'RESET_TOURNAMENT_AWARDS_REQUEST_SUCCESS',
  RESET_TOURNAMENT_AWARDS_REQUEST_FAILURE: 'RESET_TOURNAMENT_AWARDS_REQUEST_FAILURE',

  // 매장 대회 수상자 설정
  TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST: 'TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST',
  TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_SUCCESS: 'TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_SUCCESS',
  TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_FAILURE: 'TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_FAILURE',

  // 매장 대회 시상 발표
  TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST: 'TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST',
  TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_SUCCESS: 'TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_SUCCESS',
  TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_FAILURE: 'TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_FAILURE',
};

/* ============================================================================================================ */
/* ============================================================================================================ */
/* 콘텐츠 아이템 */

// 내 보관함
export const Inventory = {
  // 내 보관함 목록 조회
  LOAD_INVENTORY_LIST_REQUEST: 'LOAD_INVENTORY_LIST_REQUEST',
  LOAD_INVENTORY_LIST_SUCCESS: 'LOAD_INVENTORY_LIST_SUCCESS',
  LOAD_INVENTORY_LIST_FAILURE: 'LOAD_INVENTORY_LIST_FAILURE',
  PURCHASE_SHOP_ITEM_ID: 'PURCHASE_SHOP_ITEM_ID',
  RESET_TIMER: 'RESET_TIMER',
};

// 케이골프 상점
export const ItemShop = {
  // 내 보관함 목록 조회
  LOAD_ITEM_SHOP_LIST_REQUEST: 'LOAD_ITEM_SHOP_LIST_REQUEST',
  LOAD_ITEM_SHOP_LIST_SUCCESS: 'LOAD_ITEM_SHOP_LIST_SUCCESS',
  LOAD_ITEM_SHOP_LIST_FAILURE: 'LOAD_ITEM_SHOP_LIST_FAILURE',
};

// 콘텐츠 아이템 결제
export const ItemPayment = {
  CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN: 'CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN',
  ADD_ITEM_PAYMENT_METHOD_REQUEST: 'ADD_ITEM_PAYMENT_METHOD_REQUEST',
  ADD_ITEM_PAYMENT_METHOD_SUCCESS: 'ADD_ITEM_PAYMENT_METHOD_SUCCESS',
  ADD_ITEM_PAYMENT_METHOD_FAILURE: 'ADD_ITEM_PAYMENT_METHOD_FAILURE',
  ITEM_PAYMENT_SUCCESS: 'ITEM_PAYMENT_SUCCESS',
  CHANGE_ITEM_PAYMENT_HISTORY_SEARCH_FILTER : 'CHANGE_ITEM_PAYMENT_HISTORY_SEARCH_FILTER',
  LOAD_ITEM_PAYMENT_HISTORY_LIST_REQUEST: 'LOAD_ITEM_PAYMENT_HISTORY_LIST_REQUEST',
  LOAD_ITEM_PAYMENT_HISTORY_LIST_SUCCESS: 'LOAD_ITEM_PAYMENT_HISTORY_LIST_SUCCESS',
  LOAD_ITEM_PAYMENT_HISTORY_LIST_FAILURE: 'LOAD_ITEM_PAYMENT_HISTORY_LIST_FAILURE',
};

// 콘텐츠 아이템 알림 팝업 조건
export const ItemNotification = {
  LOAD_ITEM_NOTIFICATION_REQUEST: 'LOAD_ITEM_NOTIFICATION_REQUEST',
  LOAD_ITEM_NOTIFICATION_SUCCESS: 'LOAD_ITEM_NOTIFICATION_SUCCESS',
  LOAD_ITEM_NOTIFICATION_FAILURE: 'LOAD_ITEM_NOTIFICATION_FAILURE',
};
/* ============================================================================================================ */